import { createSlice } from "@reduxjs/toolkit"

const getLPCIndexByPos = (lpcs, pos) => {
	return lpcs.findIndex((lpc) => lpc.posicao == pos)
}

const getControleIndexByPos = (lpc, pos) => {
	return lpc.controles.findIndex((c) => c.posicao == pos)
}

const resequenceControles = (controles = []) => {
	if (!Array.isArray(controles) || controles.length === 0) return controles
	return [...controles]
		.sort((a, b) => (a.posicao || 0) - (b.posicao || 0))
		.map((c, index) => ({ ...c, posicao: index + 1 }))
}

const initialState = {
	form: {
		nome: "",
		processo: "",
		fluxoDeProcesso: "",
		linhasDePlanoDeControle: [],
		/* linhasDePlanoDeControleToRemove: [],
		controlesToRemove: [], */
	},
	formCopy: {}
}

const planoDeControleReducer = createSlice({
	name: "planoDeControleReducer",
	initialState,
	reducers: {
		setProcesso(state, action) {
			state.form.processo = action.payload
		},
		setFluxo(state, action) {
			state.form.fluxoDeProcesso = action.payload
		},
		setLinhaDePlanoDeControle(state, action) {
			if (state.form.linhasDePlanoDeControle) {
				if (Array.isArray(action.payload))
					state.form.linhasDePlanoDeControle = [
						...state.form.linhasDePlanoDeControle,
						...action.payload,
					]
				else
					state.form.linhasDePlanoDeControle = [
						...state.form.linhasDePlanoDeControle,
						action.payload,
					]
			} else {
				if (Array.isArray(action.payload))
					state.form.linhasDePlanoDeControle = action.payload
				else
					state.form.linhasDePlanoDeControle = new Array(
						action.payload
					)
			}
		},
		overWriteLpcs(state, action) {
			state.form.linhasDePlanoDeControle = action.payload
		},

		setEspecificacaoControle(state, action) {
			let { linhaIndex, controleIndex } = action.payload

			state.form.linhasDePlanoDeControle[linhaIndex].controles[
				controleIndex
			].especificacao = action.payload
		},
		setAcionadoresControleDeProcesso(state, action) {
			state.controleDeProcesso.acionadores = action.payload
		},
		setPosicaoLinhaDePlanoDeControle(state, action) {
			let { index, newPosicao } = action.payload
			state.form.linhasDePlanoDeControle[index].posicao = newPosicao
		},
		setUpdateSingleLPC(state, action) {
			let index
			if (action.payload.index) index = action.payload.index
			else
				index = state.form.linhasDePlanoDeControle.findIndex(
					(lpc) => lpc.id == action.payload.id
				)

			state.form.linhasDePlanoDeControle[index] = action.payload
			const { oldPos, newPos } = action.payload;

			/* 0. aborta se posições vazias ou iguais */
			const sanitiza = (v) =>
				v === null || v === undefined || (typeof v === "string" && v.trim() === "")
					? undefined
					: Number(v);

			const from = sanitiza(oldPos);
			const to = sanitiza(newPos);
			if (from === undefined || to === undefined || from === to) return;

			/* 1. garante que oldPos exista na lista */
			const lista = state.form.linhasDePlanoDeControle;
			if (!lista.some((l) => l.posicao === from)) return;

			/* 2. aplica as mudanças */
			const reordenada = lista
				.map((item) => {
					if (item.posicao === from) {
						/* move a linha alvo para a nova posição */
						return { ...item, posicao: to };
					}

					/* --- mover PARA CIMA (ex.: 5 → 2) -------------------- */
					if (to < from && item.posicao >= to && item.posicao < from) {
						// itens entre 'to' e 'from-1' descem (+1)
						return { ...item, posicao: item.posicao + 1 };
					}

					/* --- mover PARA BAIXO (ex.: 1 → 3) -------------------- */
					if (to > from && item.posicao <= to && item.posicao > from) {
						// itens entre 'from+1' e 'to' sobem (+1)  ← ajuste aqui
						return { ...item, posicao: item.posicao - 1 };
						// Se você quer empurrar p/ baixo (2→3), troque –1 por +1:
						// return { ...item, posicao: item.posicao + 1 };
					}

					return item; // sem alteração
				})
				.sort((a, b) => a.posicao - b.posicao);

			/* 3. grava na store */
			state.form.linhasDePlanoDeControle = reordenada;
		},

		setUpdateSingleControle(state, action) {
			let { posicao, posLPC } = action.payload
			let indexToUpdate = getLPCIndexByPos(
				state.form.linhasDePlanoDeControle,
				posLPC
			)
			let indexControle = getControleIndexByPos(state.form.linhasDePlanoDeControle[indexToUpdate], posicao)
			if (indexControle >= 0) {
				state.form.linhasDePlanoDeControle[indexToUpdate].controles[indexControle] = action.payload
			} else {
				state.form.linhasDePlanoDeControle[indexToUpdate].controles = [
					...state.form.linhasDePlanoDeControle[indexToUpdate].controles,
					action.payload,
				]
			}

			// Garante sequência incremental 1..N após a edição
			state.form.linhasDePlanoDeControle[indexToUpdate].controles =
				resequenceControles(
					state.form.linhasDePlanoDeControle[indexToUpdate].controles
				)
		},
		removeControleFromLPC(state, action) {
			let { indexControle, posLPC } = action.payload
			let indexToUpdate = getLPCIndexByPos(
				state.form.linhasDePlanoDeControle,
				posLPC
			)
			state.form.linhasDePlanoDeControle[indexToUpdate].controles[
				indexControle
			].excluded = true
		},
		copiarControle(state, action) {
			state.form.controleCopy = action.payload
		},

		apendSingleControle(state, action) {
			let { posLPC } = action.payload
			let indexToUpdate = getLPCIndexByPos(
				state.form.linhasDePlanoDeControle,
				posLPC
			)
			if (!state.form.linhasDePlanoDeControle[indexToUpdate].controles)
				state.form.linhasDePlanoDeControle[indexToUpdate].controles = []
			state.form.linhasDePlanoDeControle[indexToUpdate].controles = resequenceControles([
				...state.form.linhasDePlanoDeControle[indexToUpdate].controles,
				action.payload,
			])
		},

		apendRecurso(state, action) {
			let { posLPC } = action.payload
			let indexToUpdate = getLPCIndexByPos(
				state.form.linhasDePlanoDeControle,
				posLPC
			)
			state.form.linhasDePlanoDeControle[indexToUpdate].recurso =
				action.payload
			state.form.linhasDePlanoDeControle[
				indexToUpdate
			].recursoId = `${action.payload.id}`
		},
		setUpdateOperacaoLPC(state, action) {
			let { posicao, operacao } = action.payload
			let indexToUpdate = getLPCIndexByPos(
				state.form.linhasDePlanoDeControle,
				posicao
			)
			state.form.linhasDePlanoDeControle[
				indexToUpdate
			].operacao = operacao
			state.form.linhasDePlanoDeControle[
				indexToUpdate
			].operacaoId = `${operacao.id}`
		},
		setUpdateEspecificacaoControle(state, action) {
			let { indexControle, posLPC } = action.payload
			let indexToUpdate = getLPCIndexByPos(
				state.form.linhasDePlanoDeControle,
				posLPC
			)
			state.form.linhasDePlanoDeControle[indexToUpdate].controles[
				indexControle
			].especificacao = action.payload
		},
		setUpdateFrequenciaControle(state, action) {
			let { indexControle, posLPC } = action.payload
			let indexToUpdate = getLPCIndexByPos(
				state.form.linhasDePlanoDeControle,
				posLPC
			)
			state.form.linhasDePlanoDeControle[indexToUpdate].controles[
				indexControle
			].frequencia = action.payload
		},
		setNome(state, action) {
			state.form.nome = action.payload
		},
		setLinhasDePlanoDeControle(state, action) {
			state.form.linhasDePlanoDeControle = action.payload
		},
		populateToEdit(state, action) {
			const form = action.payload

			// Normaliza a sequência dos controles em todas as linhas ao carregar o plano
			if (Array.isArray(form.linhasDePlanoDeControle)) {
				form.linhasDePlanoDeControle = form.linhasDePlanoDeControle.map(lpc => ({
					...lpc,
					controles: resequenceControles(lpc.controles || []),
				}))
			}

			state.form = form
			state.formCopy = form
		},
		clear(state, action) {
			state.form = initialState.form
		},
		removeLinhaPlanoDeControle(state, action) {
			const lpcIndex = state.form.linhasDePlanoDeControle.findIndex(
				(lpc) => lpc.posicao == action.payload
			)
			state.form.linhasDePlanoDeControle[lpcIndex].excluded = true
			state.form.linhasDePlanoDeControle[
				lpcIndex
			].controles = state.form.linhasDePlanoDeControle[
				lpcIndex
			].controles.map((controle) => ({ ...controle, excluded: true }))
		},
		undoRemoveLinhaPlanoDeControle(state, action) {
			const lpcIndex = state.form.linhasDePlanoDeControle.findIndex(
				(lpc) => lpc.posicao == action.payload
			)
			state.form.linhasDePlanoDeControle[lpcIndex].excluded = false
			state.form.linhasDePlanoDeControle[
				lpcIndex
			].controles = state.form.linhasDePlanoDeControle[
				lpcIndex
			].controles.map((controle) => ({ ...controle, excluded: false }))
		},
		undoRemoveControleFromLPC(state, action) {
			let { indexControle, posLPC } = action.payload
			let indexToUpdate = getLPCIndexByPos(
				state.form.linhasDePlanoDeControle,
				posLPC
			)
			state.form.linhasDePlanoDeControle[indexToUpdate].controles[
				indexControle
			].excluded = false
		},
	},
})

export const {
	setProcesso,
	setFluxo,
	overWriteLpcs,
	setOpercaoLinhaPlanoDeControle,
	setLinhaDePlanoDeControle,
	apendSingleControle,
	apendRecurso,
	setNome,
	copiarControle,
	clear: clearPlanoDeControleForm,
	setEspecificacaoControle,
	setAcionadoresControleDeProcesso,
	removeLinhaPlanoDeControle,
	setPosicaoLinhaDePlanoDeControle,
	setUpdateFrequenciaControle,
	populateToEdit: populateToEditPlanoDeControleReducer,
	setUpdateSingleLPC,
	removeControleFromLPC,
	setUpdateSingleControle,
	setUpdateEspecificacaoControle,
	setUpdateOperacaoLPC,
	setLinhasDePlanoDeControle,
	undoRemoveLinhaPlanoDeControle,
	undoRemoveControleFromLPC,
} = planoDeControleReducer.actions
export default planoDeControleReducer.reducer
